// extracted by mini-css-extract-plugin
export default {"root":"RemoveLearnersButton_root__DJsg+"};